// extracted by mini-css-extract-plugin
module.exports = {"offerIconsList":"offericons_offerIconsList__Xf4pu","desktopWhiteFilter":"offericons_desktopWhiteFilter__sQpsR","whiteFilter":"offericons_whiteFilter__8mFya"};